<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  value?: number
  showLabel?: boolean
}>()

const percentage = computed(() => Math.min(100, Math.max(0, props.value ?? 0)))
</script>

<template>
  <div class="w-full">
    <div
      class="h-2 rounded-full overflow-hidden bg-[color:var(--color-surface-muted)]"
    >
      <div
        class="h-full bg-primary rounded-full transition-all duration-300 ease-in-out"
        :style="{ width: `${percentage}%` }"
      />
    </div>
    <p
      v-if="props.showLabel"
      class="text-xs text-[color:var(--color-ink-soft)] mt-1 text-right"
    >
      {{ percentage }}%
    </p>
  </div>
</template>
